import { Component } from './Component'
import { useTw } from '../../../../../utils/Styles'
import { localizeString } from '../../../../../utils'
import { StatusPageQuery } from '../StatusPage.generated'

type GroupProps = {
  components: StatusPageQuery['Profile']['statusPage']['components']
  group?: StatusPageQuery['Profile']['statusPage']['componentGroups'][0]
}

function Group({ group, components = [] }: GroupProps) {
  const tw = useTw()
  return (
    <>
      <article>
        {group ? (
          <header className={tw`relative`}>
            <div
              aria-hidden="true"
              className={tw`absolute inset-0 ml-4 pr-4 flex items-center`}
            >
              <div className={tw`w-full border-t border-gray-300`}></div>
            </div>
            <div className={tw`relative ml-4 flex justify-start`}>
              <span className={tw`bg-gray-50 text-sm pr-2`}>
                {localizeString(group.name)}
              </span>
            </div>
          </header>
        ) : null}
        <div className={tw`p-2 divide-y divide-gray-300`}>
          {components?.map((component) => (
            <Component key={component._id} component={component} />
          ))}
        </div>
      </article>
    </>
  )
}

type ComponentsGroup = {
  groups: StatusPageQuery['Profile']['statusPage']['componentGroups']
  components: StatusPageQuery['Profile']['statusPage']['components']
}

export function StatusPageComponents({
  groups = [],
  components = [],
}: ComponentsGroup) {
  return (
    <div>
      <Group components={components.filter((_) => !_.groupId)} />
      {groups
        .filter((group) => components.some((_) => _.groupId === group._id))
        .map((group) => (
          <Group
            group={group}
            key={group._id}
            components={components?.filter((_) => _.groupId === group._id)}
          />
        ))}
    </div>
  )
}
